import { createSelector } from 'reselect'
import {
  NotificationSettingListModel,
  NotificationSettingListResponse,
} from 'src/models/notificationSetting.models'
import { RootState } from 'src/redux/createRootReducer'

const selectNotificationSettingListResponsesFromState = (
  state: RootState,
): Record<string, NotificationSettingListResponse> =>
  state.data.notificationSettings.listResponses

const selectNotificationSettingListModelsFromState = createSelector(
  [selectNotificationSettingListResponsesFromState],
  (creditCardListResponses) =>
    Object.values(creditCardListResponses).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new NotificationSettingListModel(curr),
      }),
      {} as Record<string, NotificationSettingListModel>,
    ),
)

const selectNotificationSettingOrderFromState = (state: RootState): string[] =>
  state.data.notificationSettings.order
export const selectNotificationSettingListModelList = createSelector(
  [
    selectNotificationSettingListModelsFromState,
    selectNotificationSettingOrderFromState,
  ],
  (notificationSettings, idList) =>
    idList.map((id) => notificationSettings[id]),
)
